$(document).ready(function () {
  $(".dropdown").select2({
    minimumResultsForSearch: Infinity,
  });

  $(".dropdown").change(function () {
    var selected = $(this).val();
    console.log("Dropdown Selected Value is: ", selected);
    $(".charging-section").hide();
    $("#" + selected).show();

    // Update the value of all dropdowns with the class "dropdown"
    $(".dropdown").not(this).val(selected).trigger("change.select2"); // Ignore the one that triggered the change
  });
});
